// assets
import { ContactEmergency, QrCode, PriceChange } from '@mui/icons-material';

// constant
const icons = { ContactEmergency, QrCode, PriceChange };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const billing = {
    id: 'billing',
    title: 'Billing',
    type: 'group',
    authority: 'BILLING_VIEW',
    children: [
        {
            id: 'contract',
            title: 'Contract',
            type: 'item',
            url: '/billing/contract',
            icon: icons.ContactEmergency,
            // breadcrumbs: false
        },
        {
            id: 'promotionCode',
            title: 'Promotion Code',
            type: 'item',
            url: '/billing/promotion',
            icon: icons.QrCode,
            // breadcrumbs: false
        },
        {
            id: 'statement',
            title: 'Statement',
            type: 'item',
            url: '/billing/statement',
            icon: icons.PriceChange,
            // breadcrumbs: false
        },
        {
            id: 'statement-test',
            title: 'Statement Test',
            type: 'item',
            url: '/billing/statement-test',
            icon: icons.PriceChange,
            // breadcrumbs: false
        },
    ]
};

export default billing;
